
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, bool_type, list_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, SetId, FormState__startLoading, FormState__setValidationResponse_5219762A, RequestedValue$1, FormState_get_empty, RequestedValue$1_$reflection, FormState_$reflection, CustomerConfiguration_$reflection, TokenDataDto_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { Receiver_$reflection } from "../../Shared/User.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { HookFlow_hasMandatoryUncompletedHooks, HookFlowProcedureModal, HookFlowSections, HookFlow_update, HookFlow_completedProcedureIds, HookFlow_initReturn, HookFlowState_$reflection, HookFlowMsg_$reflection } from "../../Widgets/Procedure/Hooks.js";
import { DataTransfer_UnassignSetDto, DataTransfer_UnassignSetDto_$reflection, DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ProcedureEntityReferenceDto } from "../../Shared/Procedure.js";
import { max, tryPick, sumBy, choose, ofArray, filter, append as append_1, singleton as singleton_1, empty, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_ofEffect, Cmd_map, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, comparePrimitives, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unassignCmd } from "../../Requests/Set.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { isComplete, SetReturnCompletenessCheck, isRequired } from "./CompletenessCheck.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnassignedResponse", "OnUnassign", "SetComment", "ReceiverFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded", "HookMsg", "SetToolConfirmed"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.UnassignDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", Receiver_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]], [["Item", HookFlowMsg_$reflection()]], [["Item1", string_type], ["Item2", bool_type]]]);
}

class State extends Record {
    constructor(Set$, UserData, CustomerConfiguration, FormState, SuccessCallback, OnClose, Receiver, Dto, SenderImageFiles, ImageUploading, Hooks, ConfirmedToolIds) {
        super();
        this.Set = Set$;
        this.UserData = UserData;
        this.CustomerConfiguration = CustomerConfiguration;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Receiver = Receiver;
        this.Dto = Dto;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
        this.Hooks = Hooks;
        this.ConfirmedToolIds = ConfirmedToolIds;
    }
}

function State_$reflection() {
    return record_type("Sets.Dialog.UnassignDialog.State", [], State, () => [["Set", DataTransfer_DetailSet_$reflection()], ["UserData", TokenDataDto_$reflection()], ["CustomerConfiguration", CustomerConfiguration_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Receiver", RequestedValue$1_$reflection(Receiver_$reflection())], ["Dto", DataTransfer_UnassignSetDto_$reflection()], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type], ["Hooks", HookFlowState_$reflection()], ["ConfirmedToolIds", list_type(string_type)]]);
}

const maxSenderImages = 5;

function init(set$, userData, customerConfiguration, successCallback, onClose) {
    const patternInput = HookFlow_initReturn(new ProcedureEntityReferenceDto(3, [set$.Id]), map((label) => parse(label.Id), set$.AssignedLabel));
    return [new State(set$, userData, customerConfiguration, FormState_get_empty(), successCallback, onClose, new RequestedValue$1(0, []), new DataTransfer_UnassignSetDto("", empty(), undefined, undefined, undefined), empty(), false, patternInput[0], empty()), Cmd_batch(toList(delay(() => {
        let matchValue;
        return append((matchValue = set$.LocationInformation.AssignedReceiverId, (matchValue == null) ? singleton(Cmd_none()) : singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_2;
            return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), Receiver_$reflection()));
            }, refreshOn)))(true).then((_arg) => {
                const result_1 = _arg;
                return (result_1.tag === 1) ? (Promise.resolve((() => {
                    throw new ValidationOnGetRequest(result_1.fields[0]);
                })())) : (Promise.resolve(result_1.fields[0]));
            });
        })), concat("/api/receivers/receiver/", ...matchValue), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1]))))), delay(() => singleton(Cmd_map((Item_2) => (new Msg(7, [Item_2])), patternInput[1]))));
    })))];
}

function update(msg, state) {
    let bind$0040, bind$0040_1, file_1;
    switch (msg.tag) {
        case 8: {
            const toolId = msg.fields[0];
            return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading, state.Hooks, msg.fields[1] ? List_distinct(append_1(state.ConfirmedToolIds, singleton_1(toolId)), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }) : filter((id) => (id !== toolId), state.ConfirmedToolIds)), Cmd_none()];
        }
        case 0: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Set, state.UserData, state.CustomerConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Set, state.UserData, state.CustomerConfiguration, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 3:
            return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Dto, state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
        case 1: {
            const matchValue = state.Set.LocationInformation.AssignedReceiverId;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const assignedReceiver = matchValue;
                const senderImageUrls = choose((f) => {
                    if (f.tag === 1) {
                        return f.fields[0].ImageUrl;
                    }
                    else {
                        return undefined;
                    }
                }, state.SenderImageFiles);
                return [new State(state.Set, state.UserData, state.CustomerConfiguration, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), unassignCmd(new SetId(parse(state.Set.Id)), (bind$0040 = state.Dto, new DataTransfer_UnassignSetDto(bind$0040.Comment, senderImageUrls, HookFlow_completedProcedureIds(state.Hooks), state.ConfirmedToolIds, bind$0040.SignatureUrl)), (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(4, [Item_3])))];
            }
        }
        case 2:
            return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, (bind$0040_1 = state.Dto, new DataTransfer_UnassignSetDto(msg.fields[0], bind$0040_1.SenderImageUrls, bind$0040_1.CompletedProcedureIds, bind$0040_1.ConfirmedToolIds, bind$0040_1.SignatureUrl)), state.SenderImageFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
        case 4:
            return [new State(state.Set, state.UserData, state.CustomerConfiguration, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, false, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
        case 5: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y_1) => ((x_1 + y_1) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, newFiles, true, state.Hooks, state.ConfirmedToolIds), Cmd_uploadImage((Item_4) => (new Msg(6, [Item_4])), (Item_5) => (new Msg(4, [Item_5])), formData)];
                }
                default:
                    return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, newFiles, state.ImageUploading, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
            }
        }
        case 6: {
            const response_2 = msg.fields[0];
            switch (response_2.tag) {
                case 0:
                    return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks, state.ConfirmedToolIds), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks, state.ConfirmedToolIds), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append_1(singleton_1(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                    })) | 0;
                    return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, append_1(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton_1(new DnDFormImage(1, [{
                        ImageUrl: response_2.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false, state.Hooks, state.ConfirmedToolIds), Cmd_none()];
                }
            }
        }
        default: {
            const patternInput = HookFlow_update(msg.fields[0], state.Hooks);
            return [new State(state.Set, state.UserData, state.CustomerConfiguration, state.FormState, state.SuccessCallback, state.OnClose, state.Receiver, state.Dto, state.SenderImageFiles, state.ImageUploading, patternInput[0], state.ConfirmedToolIds), Cmd_map((Item) => (new Msg(7, [Item])), patternInput[1])];
        }
    }
}

function DialogBody(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const formState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems_2 = toList(delay(() => {
        let arg_1;
        return append(singleton(reactElement("p", {
            children: (arg_1 = {
                user: props.Receiver.Name,
            }, patternInput[1].t("tool.dialog_unassign_tool_query", arg_1)),
        })), delay(() => {
            let elems;
            return append(singleton(reactElement("div", createObj(singleton_1((elems = [createElement(TextArea, {
                ComponentState: formState,
                Label: t("general.comment"),
                OnChange: props.SetComment,
                TestId: "unassign-tool-dialog-comment-test-id",
                Value: props.Comment,
            })], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
                let elems_1;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "",
                    Text: t("assignment_notification.sender_images"),
                }), createElement(ImageUpload, {
                    ComponentState: props.ImageUploading ? "disabled" : formState,
                    SelectedFiles: props.SenderImageFiles,
                    SetSelectedFile: props.SetSelectedSenderFiles,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(isRequired(props.CustomerConfiguration) ? singleton(createElement(SetReturnCompletenessCheck, {
                    Configuration: props.CustomerConfiguration,
                    ConfirmedToolIds: props.ConfirmedToolIds,
                    FormState: props.FormState,
                    OnToolConfirmed: props.OnToolConfirmed,
                    Set: props.Set,
                })) : empty_1(), delay(() => append(singleton(createElement(HookFlowSections, {
                    Dispatch: props.HookDispatch,
                    FormState: props.FormState,
                    ReceiverTitleKey: "procedure.hooks.receiver_procedures_return",
                    SenderTitleKey: "procedure.hooks.sender_procedures_return",
                    State: props.Hooks,
                    TestIdPrefix: "return-set",
                })), delay(() => {
                    const matchValue = FormState__getValidation(props.FormState, t, "global");
                    if (matchValue == null) {
                        return empty_1();
                    }
                    else {
                        return singleton(createElement(ErrorAlert, {
                            Label: matchValue,
                        }));
                    }
                }))))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OpenUnassignDialog(props) {
    let elems, Title, Label_1;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Set, props.UserData, props.CustomerConfiguration, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    if (state_1.Set.LocationInformation.AssignedReceiverId == null) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(singleton_1((elems = [createElement(HookFlowProcedureModal, {
            Dispatch: (arg) => {
                dispatch(new Msg(7, [arg]));
            },
            State: state_1.Hooks,
        }), createElement(Dialog, (Title = t("tool.back_to_storage"), {
            Body: toList(delay(() => {
                const matchValue_1 = state_1.Receiver;
                return (matchValue_1.tag === 0) ? singleton(createElement(Skeleton, {
                    Variant: "normal",
                })) : singleton(createElement(DialogBody, {
                    Comment: state_1.Dto.Comment,
                    ConfirmedToolIds: state_1.ConfirmedToolIds,
                    CustomerConfiguration: state_1.CustomerConfiguration,
                    FormState: state_1.FormState,
                    HookDispatch: (arg_1) => {
                        dispatch(new Msg(7, [arg_1]));
                    },
                    Hooks: state_1.Hooks,
                    ImageUploading: state_1.ImageUploading,
                    OnToolConfirmed: (tupledArg) => {
                        dispatch(new Msg(8, [tupledArg[0], tupledArg[1]]));
                    },
                    Receiver: matchValue_1.fields[0],
                    SenderImageFiles: state_1.SenderImageFiles,
                    Set: state_1.Set,
                    SetComment: (value) => {
                        dispatch(new Msg(2, [value]));
                    },
                    SetSelectedSenderFiles: (files) => {
                        dispatch(new Msg(5, [files]));
                    },
                }));
            })),
            Controls: ofArray([createElement(TextButton, {
                ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                Label: t("general.cancel"),
                OnClick: props.OnClose,
                TestId: "close-unassign-dialog-test-id",
                Variant: "blueButton",
            }), createElement(TextButton, (Label_1 = t("general.save"), {
                ComponentState: (((state_1.FormState.IsLoading ? true : state_1.ImageUploading) ? true : HookFlow_hasMandatoryUncompletedHooks(state_1.Hooks)) ? true : !isComplete(state_1.CustomerConfiguration, state_1.Set, state_1.ConfirmedToolIds)) ? "disabled" : "enabled",
                Label: Label_1,
                OnClick: () => {
                    dispatch(new Msg(1, []));
                },
                TestId: "save-unassign-dialog-test-id",
                Variant: "blueButton",
            }))]),
            IsOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: Title,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
    }
}

